import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./BlogManage.css";
import Swal from "sweetalert2";
const BlogManage = () => {
const navigate = useNavigate();
  const imagePath = `${IMAGE_BASE_URL}/uploads/blogs/`;

  const [getblogdata, setblogdata] = useState([]);
const [getImage, setImage] = useState(false);

const [headerImage, setHeaderImage] = useState(null);

const [previewImage, setPreviewImage] = useState("");

 const [getPageId, setPageId] = useState([]);
  const [getPageImg, setPageImg] = useState([]);

  const [getImgAlt, setImgAlt] = useState([]);

const [currentPage, setCurrentPage] = useState(1);
const [blogsPerPage] = useState(10); // show 6 blogs per page

  useEffect(() => {
    fetchBlogData();
    fetchHeaderImage();
  }, []);


const handleViewDetails = (pageID) => {
  navigate(`/blog-details/${pageID}`);
};


const handleDeleteBlog = async (pageID) => {

  const confirm = await Swal.fire({
    title: "Delete Blog?",
    text: "Do you want to delete this blog?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes Delete"
  });

  if (!confirm.isConfirmed) return;

  try {

    const res = await api.delete(
      `/adminBlog/deleteBlog/${pageID}`
    );

    if (res.data.success) {

      Swal.fire(
        "Deleted!",
        "Blog deleted successfully",
        "success"
      );

      fetchBlogData();

    }

  } catch (error) {

    toast.error("Failed to delete blog");

  }

};

const handleEditPage = (pageID) => {
  navigate(`/edit-blog/${pageID}`);
};



  // Fetch Page Data
  const fetchBlogData = async () => {
    try {
      const res = await api.get("/adminBlog/getblogData");
      const data = res.data?.data || [];
      setblogdata(data);
    } catch (error) {
      toast.error("Failed to load blog data");
    }
  };

   const fetchHeaderImage = async () => {

  try {

    const pageId = 1;

    const res = await api.get(
      `/adminBlog/headerImage?pageId=${pageId}`
    );

    const data = res.data?.data || [];

    setPageId(data[0].page_id);

    setImgAlt(data[0].img_alt);

    
    setPageImg(data[0].page_img);


  } catch (error) {

    toast.error(
      "Failed to Header Image"
    );

  }

};


 const handleStatusChange = async (id, is_active) => {
    try {
  

      await api.put("/adminBlog/blog-status", { id, is_active});
      toast.success("Status updated");
          fetchBlogData(); // Revert on error
    } catch {
      toast.error("Failed to update status");
          fetchBlogData(); // Revert on error
    }
  };

const handleHeaderImageChange = (e) => {

  const file = e.target.files[0];

  setHeaderImage(file);

  if (file) {
    setPreviewImage(
      URL.createObjectURL(file)
    );
  }

};

const handleUpdateHeaderImage = async (getPageId) => {

  try {

    if (!headerImage) {
      toast.error("Please select image");
      return;
    }

    const formData = new FormData();

    formData.append(
      "pageimg",
      headerImage
    );

    formData.append("img_alt", getImgAlt);

    const res = await api.put(
      `/adminBlog/updateHeaderImage/${getPageId}`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    if (res.data.success) {

      toast.success(
        "Header image updated"
      );

      setImage(false);

      fetchBlogData();
      fetchHeaderImage();
window.location.reload();
    }

  } catch (error) {

    console.log(error);

    toast.error(
      "Failed to update image"
    );

  }

};

const backpage = async (blogId) => {
  location.reload();
}

const indexOfLastBlog = currentPage * blogsPerPage;
const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
const currentBlogs = getblogdata.slice(indexOfFirstBlog, indexOfLastBlog);
const totalPages = Math.ceil(getblogdata.length / blogsPerPage);

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Manage</h4>

          <Link
            to={"/add-blog"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add 
          </Link>
        </div>
      </div>

      {/* Table */}
      <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
        <div className="table-responsive">
  <table className="table table-hover table-sm align-middle mb-0 d-none">

  <thead className="bg-light">
    <tr>

      <th className="text-center" style={{width:"100px"}}>
        Header Image
      </th>

      <th className="text-center">
        {previewImage ? (
          <img
            src={previewImage}
            alt="Preview"
            style={{
              width: "120px",
              height: "70px",
              objectFit: "cover",
              borderRadius: "6px"
            }}
          />
        ) : (
          <img
  src={`${imagePath}${getPageImg}`}
  alt="Header"
  style={{
    width: "100%",
    height: "70px",
    objectFit: "cover",
    borderRadius: "6px"
  }}
/>
        )}
      </th>

      <th className="text-center">

        {!getImage ? (

          <button
            className="btn btn-sm btn-primary"
            onClick={() => setImage(true)}
          >
            <i
              className="fa fa-pencil"
              aria-hidden="true"
            ></i>
          </button>

        ) : (

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center"
            }}
          >

            <input
              type="file"
              className="form-control"
              onChange={
                handleHeaderImageChange
              }
            />
               <input
              type="text"
              className="form-control"
              placeholder="Enter Alt Title"
              value={getImgAlt}
              onChange={(e) =>
                      setImgAlt(e.target.value)
                    }
            />
<div style={{display:"flex"}}>
            <button
              className="btn btn-sm btn-success"
              onClick={() =>
                handleUpdateHeaderImage(
                  getPageId
                )
              }
            >
              <i
                className="fa fa-upload"
                aria-hidden="true"
              ></i>
            </button>

            <button
              className="btn btn-sm btn-danger"
              onClick={() =>
                backpage(
                )
              }
            >
              <i class="fa fa-times-circle" aria-hidden="true"></i>
            </button>
</div>
          </div>

        )}

      </th>

    </tr>
  </thead>

</table>
          <table className="table table-hover table-sm align-middle mb-0"  style={{
    tableLayout: "fixed",
    width: "100%"
  }}>

            <thead className="bg-light">
              <tr> 
                <th className="text-center"  style={{width:"5%"}}>Sl. No.</th>
                <th className="text-center" style={{width:"30%"}}>Blog Title</th>
                <th className="text-center" style={{width:"12%"}}>Blog Category</th>
                <th className="text-center" style={{width:"12%"}}>Author</th>
                <th className="text-center" style={{width:"7%"}}>Blog URL</th>
                <th className="text-center" style={{width:"10%"}}>Date</th>
                <th className="text-center" style={{width:"10%"}}>Status</th>
                <th className="text-center" style={{width:"10%"}}>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentBlogs.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center py-5 text-muted">
                    Data Not Found.
                  </td>
                </tr>
              ) : (

                currentBlogs.map((blog, index) => (
// className="title-cell"
// className="subtitle-cell"
                  <tr key={index}>
                    <td className="text-center" >{index + 1}</td>
                    <td>{blog.title}</td>
                 <td className="text-center">
  {blog.category
    ?.replace(/-/g, " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase())
  }
</td>
<td className="text-center">{blog.autherName}</td>
                    <td className="text-center">
                      <button
  className="btn btn-sm btn-success me-2"
  onClick={() => handleViewDetails(blog.id)}
>
  <i class="fa fa-eye" aria-hidden="true"></i>
</button>
  </td>

<td className="text-center">
  {new Date(blog.addedDt)
  .toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour12: false
  })
  .replace(/\//g, "-")
  .replace(",", "")}
</td>

<td className="text-center">
     <select
                        className={`form-select form-select-sm border-0 fw-bold ${blog.is_active == 1 ? "text-success bg-success-subtle" : "text-danger bg-danger-subtle"}`}
                        style={{ width: "100px", margin: "0 auto", cursor: "pointer" }}
                        value={blog.is_active}
                        onChange={(e) => handleStatusChange(blog.id, e.target.value)}
                      
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
</td>
                    <td className="text-center">
                      <button
  className="btn btn-sm btn-primary me-2"
  onClick={() => handleEditPage(blog.id)}
>
  <i className="fa fa-pencil" aria-hidden="true"></i>
</button>

                      <button className="btn btn-sm btn-danger"
                      onClick={() => handleDeleteBlog(blog.id)}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>

                ))

              )}

            </tbody>

          </table>
<div className="d-flex justify-content-center mt-3">
  <nav>
    <ul className="pagination">
      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
          Previous
        </button>
      </li>

      {Array.from({ length: totalPages }, (_, i) => (
        <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </button>
        </li>
      ))}

      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>
        </div>
        
      </div>

    </div>
  );
};

export default BlogManage;